import React from 'react';
import css from './HeartRateMonitor.module.scss';

export const HeartRateMonitor: React.FC<{
  link: string;
  img_link: string;
  device_name: string;
  device_description: string;
  badge_text: string;
  price: string;
  isScaled?: boolean;
  isExpertChoiceBadge?: boolean;
}> = ({
  link,
  img_link,
  device_name,
  device_description,
  badge_text,
  isScaled,
  price,
  isExpertChoiceBadge,
}) => {
  return (
    <a href={link} target="_blank" className={css.anchor}>
      <div className={css.container}>
        <div className={css.left_side}>
          <img
            className={`${css.image} ${isScaled ? css.image_scale : ''}`}
            src={img_link}
          />
          <div className={css.name_container}>
            <div className={css.name}>{device_name}</div>
            <div className={css.description}>{device_description}</div>
          </div>
          <div
            className={
              isExpertChoiceBadge ? css.expert_choice_badge : css.badge
            }
          >
            {badge_text}
          </div>
        </div>
        <div className={css.pricing_container}>
          <span className={css.website}>Amazon</span>
          <span className={css.website_arrow_sign}> ↗</span>
          <div className={css.price}>from {price}</div>
        </div>
      </div>
    </a>
  );
};
